export enum ERoute {
  DEFAULT = "/",
  LOGIN = "/login",
  SIGNUP = "/signup",
  DASHBOARD = "/dashboard",
  FILM = "movies",
  SERIES = "tv-series",
  SAVED = "saved",
}
